const priceContracts: {cakeAddress: string, busdAddress: string, lpAddress:string} = {
  cakeAddress: '0x678e5f70b6b582dfadb3dbd68af17801d34555c5',
  busdAddress: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
  lpAddress: '0x4f4BC5814b0DD1346A99BcC25a43bdFb74884c3d'
}

export default priceContracts